import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Card, Row, Col, Typography, Spin } from 'antd';
import UnderwaterPlot from "../../charts/Plotly/UnderwaterPlot";
import { fetchTimeSeriesData } from "../../api/timeseriesApi";

const { Title } = Typography;

const ChartViews = () => {
  const { symbol } = useParams();
  const dispatch = useDispatch();

  // Select the relevant data from Redux store
  const timeSeriesData = useSelector(state => state.timeSeries.seriesData[symbol]);
  const isLoading = useSelector(state => state.timeSeries.loadingSlice);
  const error = useSelector(state => state.timeSeries.error);

  // Fetch data on component mount or when symbol changes
  useEffect(() => {
    if (symbol) {
      const currentDate = new Date().toISOString().split('T')[0];
      // Default to 5 years of data
      const startDate = new Date(Date.now() - 5 * 365 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split('T')[0];

      dispatch(fetchTimeSeriesData({
        symbols: [symbol],
        startDate: startDate,
        endDate: currentDate
      }));
    }
  }, [dispatch, symbol]);

  // Transform the time series data for the underwater plot
  const transformedData = React.useMemo(() => {
    if (!timeSeriesData) return { prices: [], dates: [] };

    return {
      prices: timeSeriesData.map(d => d['adj close'] || d.value),
      dates: timeSeriesData.map(d => d.timestamp)
    };
  }, [timeSeriesData]);

  if (error) {
    return (
      <Card>
        <Typography.Text type="danger">
          Error loading data: {error}
        </Typography.Text>
      </Card>
    );
  }

  return (
    <div className="p-4">
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <Title level={4}>{symbol} Price Analysis</Title>
            {isLoading ? (
              <div className="flex justify-center items-center h-96">
                <Spin size="large" />
              </div>
            ) : (
              transformedData.prices.length > 0 ? (
                <UnderwaterPlot
                  prices={transformedData.prices}
                  dates={transformedData.dates}
                  title={`${symbol} Price and Drawdown Analysis`}
                  drawdownThreshold={-10} // 10% drawdown threshold
                  height={600}
                  colors={{
                    price: 'rgba(0, 100, 180, 0.8)',
                    drawdown: 'rgba(255, 44, 44, 0.7)',
                    threshold: 'rgba(255, 152, 0, 0.5)',
                    grid: 'lightgrey',
                    background: 'white'
                  }}
                />
              ) : (
                <Typography.Text>No data available for {symbol}</Typography.Text>
              )
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ChartViews;